class FarloUiWhatsOnCalendar {
    constructor(element, _config) {
        this.container = element;
        this.options = _config;
        this.minDate = new Date(this.container.dataset.startMonth);
        this.maxDate = new Date(this.container.dataset.endMonth);
        if (this.container.dataset && this.container.dataset.startMonth) {
            this.currentDate = new Date(this.container.dataset.startMonth);
        } else {
            this.currentDate = new Date();
        }
        this.render();
        this.initLightbox();
        window.addEventListener('resize', this.render.bind(this));
    }

    renderHeader() {
        const header = document.createElement('div');
        header.classList.add('farlo-ui-ticket-calendar__header');

        const prevButton = document.createElement('button');
        prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
        prevButton.innerHTML = '&#10094;';

        if (parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) >
            parseInt(this.minDate.getFullYear().toString() + this.minDate.getMonth().toString(), 10)) {
            prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            prevButton.addEventListener('click', () => this.prevMonth());
        } else {
            prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }

        const title = document.createElement('h2');
        title.classList.add('farlo-ui-ticket-calendar__header-month-year');
        title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });

        const nextButton = document.createElement('button');
        nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
        nextButton.innerHTML = '&#10095;';

        if (parseInt(this.currentDate.getFullYear().toString() + this.currentDate.getMonth().toString(), 10) <
            parseInt(this.maxDate.getFullYear().toString() + this.maxDate.getMonth().toString(), 10)) {
            nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            nextButton.addEventListener('click', () => this.nextMonth());
        } else {
            nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }

        header.appendChild(prevButton);
        header.appendChild(title);
        header.appendChild(nextButton);

        this.container.appendChild(header);
        this.renderAvailabilityKey();
    }

    renderAvailabilityKey() {
        const availabilityKey = document.createElement('div');
        availabilityKey.classList.add('farlo-ui-ticket-calendar__availability-key');

        const keys = [
            { label: 'Sold Out', class: 'sold-out' },
            { label: 'Last Few', class: 'last-few-tickets' },
            { label: 'Selling Fast', class: 'selling-fast' },
            { label: 'Available', class: 'available-tickets' },
        ];
    
        keys.forEach(key => {
            const keyItem = document.createElement('div');
            keyItem.classList.add('farlo-ui-ticket-calendar__key-item', key.class);
            keyItem.textContent = key.label;
            availabilityKey.appendChild(keyItem);
        });

        this.container.appendChild(availabilityKey);
    }

    renderDaysOfTheWeeks() {
        const div = document.createElement('div');
        div.classList.add('farlo-ui-ticket-calendar__weeks');
        const daysLetters = ['M<span>on</span>', 'T<span>ue</span>', 'W<span>ed</span>', 'T<span>hu</span>', 'F<span>ri</span>', 'S<span>at</span>', 'S<span>un</span>'];

        for (let i = 0; i < 7; i += 1) {
            const days = document.createElement('div');
            days.classList.add('farlo-ui-ticket-calendar__week-day');
            days.innerHTML = daysLetters[i];
            div.appendChild(days);
        }

        this.container.appendChild(div);
    }

    getUKDay(date) {
        let day = date.getDay();
        return day === 0 ? 6 : day - 1;
    }

    renderDaysInMonth() {
        const daysContainer = document.createElement('div');
        daysContainer.classList.add('farlo-ui-ticket-calendar__days');

        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();

        const firstDay = this.getUKDay(new Date(year, month, 1));
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let i = 0; i < firstDay; i++) {
            const blankDay = document.createElement('div');
            blankDay.classList.add('farlo-ui-ticket-calendar__day', 'farlo-ui-ticket-calendar__day--empty');
            daysContainer.appendChild(blankDay);
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const dayElement = document.createElement('div');
            dayElement.classList.add('farlo-ui-ticket-calendar__day');
            
            const dayNumber = document.createElement('div');
            dayNumber.classList.add('farlo-ui-ticket-calendar__day-number');
            dayNumber.textContent = day;
            dayElement.appendChild(dayNumber);

            const eventDate = new Date(Date.UTC(year, month, day)).toISOString().split('T')[0];
            const eventsOnThisDay = nlivenPerformances.performances.filter(event => event.start_date_time.startsWith(eventDate));
            const dateStr = new Date(eventDate).toDateString();
            if (eventsOnThisDay.length > 0) {
                if (window.innerWidth <= 768) {
                    const showEventsButton = document.createElement('button');
                    showEventsButton.classList.add('farlo-ui-ticket-calendar__show-events');
                    showEventsButton.textContent = eventsOnThisDay.length + ' Shows';
                    showEventsButton.addEventListener('click', () => this.openLightbox(eventsOnThisDay, dateStr));
                    dayElement.appendChild(showEventsButton);
                } else if (eventsOnThisDay.length > 2) {
                    for (let i = 0; i < 2; i++) {
                        this.appendEventElement(dayElement, eventsOnThisDay[i]);
                    }
                    const showMoreButton = document.createElement('button');
                    showMoreButton.classList.add('farlo-ui-ticket-calendar__show-more');
                    showMoreButton.textContent = 'Show More';
                    showMoreButton.addEventListener('click', () => this.openLightbox(eventsOnThisDay, dateStr));
                    dayElement.appendChild(showMoreButton);
                } else {
                    eventsOnThisDay.forEach(event => this.appendEventElement(dayElement, event));
                }
            }

            daysContainer.appendChild(dayElement);
        }

        this.container.appendChild(daysContainer);
    }

    appendEventElement(dayElement, event) {
        const eventElement = document.createElement('div');
        eventElement.classList.add('farlo-ui-ticket-calendar__event');
        
        const eventTime = new Date(event.start_date_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const eventInfo = document.createElement('div');
        eventInfo.classList.add('farlo-ui-ticket-calendar__event-info');

        const availability = parseInt(event.availability);
        let availabilityClass = '';
        if (availability === 0) {
            availabilityClass = 'sold-out';
        } else if (availability < 25) {
            availabilityClass = 'last-few-tickets';
        } else if (availability < 75) {
            availabilityClass = 'selling-fast';
        } else {
            availabilityClass = 'available-tickets';
        }
        if (availability == 0) {
            eventInfo.innerHTML = `<a href="javascript:void(0);" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}"><span class="farlo-ui-ticket-calendar__event-info-time">${eventTime}</span><span class="farlo-ui-ticket-calendar__event-info-title">${event.event_title}</span></a>`;
        } else {
            eventInfo.innerHTML = `<a href="${event.booking_url}" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}" target="_blank"><span class="farlo-ui-ticket-calendar__event-info-time">${eventTime}</span><span class="farlo-ui-ticket-calendar__event-info-title">${event.event_title}</span></a>`;
        }

        eventElement.classList.add(availabilityClass);

        eventElement.appendChild(eventInfo);
        dayElement.appendChild(eventElement);
    }

    async fetchEventsForMonth(y, m) {
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
        this.initLightbox();
    }

    async render() {
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
        this.initLightbox();
    }

    prevMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.render();
    }

    nextMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.render();
    }

    handleEventClick(event) {
        if (this.options.eventClick) {
            this.options.eventClick(event);
        }
    }

    initLightbox() {
        // Create lightbox HTML
        const lightboxHTML = `
            <div class="farlo-ui-ticket-calendar__lightbox">
                <div class="farlo-ui-ticket-calendar__lightbox-content">
                    <button class="farlo-ui-ticket-calendar__lightbox-close">&times;</button>
                    <div class="farlo-ui-ticket-calendar__lightbox-events"></div>
                </div>
            </div>
        `;

        // Append lightbox to body
        document.body.insertAdjacentHTML('beforeend', lightboxHTML);

        // Add event listeners
        const lightbox = document.querySelector('.farlo-ui-ticket-calendar__lightbox');
        const closeButton = lightbox.querySelector('.farlo-ui-ticket-calendar__lightbox-close');
        closeButton.addEventListener('click', () => {
            lightbox.classList.remove('open');
            document.body.classList.remove('lightbox--open');
        });
    }

    openLightbox(events, dateStr) {
        const lightbox = document.querySelector('.farlo-ui-ticket-calendar__lightbox');
        const lightboxEventsContainer = lightbox.querySelector('.farlo-ui-ticket-calendar__lightbox-events');
        
        // Clear previous events
        lightboxEventsContainer.innerHTML = '';

        const dateTitle = document.createElement("h4");
        dateTitle.classList.add("farlo-ui-ticket-calendar__lightbox-title");
        dateTitle.textContent = dateStr;
        lightboxEventsContainer.appendChild(dateTitle);

        // Append events to lightbox
        events.forEach(event => {
            const eventElement = document.createElement('div');
            eventElement.classList.add('farlo-ui-ticket-calendar__event');

            const eventTime = new Date(event.start_date_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const eventInfo = document.createElement('div');
            eventInfo.classList.add('farlo-ui-ticket-calendar__event-info');

            const availability = parseInt(event.availability);
            let availabilityClass = '';
            if (availability === 0) {
                availabilityClass = 'sold-out';
            } else if (availability < 25) {
                availabilityClass = 'last-few-tickets';
            } else if (availability < 75) {
                availabilityClass = 'selling-fast';
            } else {
                availabilityClass = 'available-tickets';
            }
            if (availability == 0) {
                eventInfo.innerHTML = `<a href="javascript:void(0);" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}"><span class="farlo-ui-ticket-calendar__event-info-time">${eventTime}</span><span class="farlo-ui-ticket-calendar__event-info-title">${event.event_title}</span></a>`;
            } else {
                eventInfo.innerHTML = `<a href="${event.booking_url}" class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}" target="_blank"><span class="farlo-ui-ticket-calendar__event-info-time">${eventTime}</span><span class="farlo-ui-ticket-calendar__event-info-title">${event.event_title}</span></a>`;
            }
    
            eventElement.classList.add(availabilityClass);

            eventElement.appendChild(eventInfo);
            lightboxEventsContainer.appendChild(eventElement);
        });

        // Open lightbox
        lightbox.classList.add('open');
        document.body.classList.add('lightbox--open');
    }
}

export default FarloUiWhatsOnCalendar;
